import { apiPut } from "../ApiMethod";
import { setDroneNest } from "../../mappers";

export const updateDroneNest = async (data, id) => {
  const response = await apiPut("_dronenest", id, data);
  return { ...response, data: setDroneNest(response.data) };
};
